/**
 * `relax-draft-validation` feature flag state, mirrored from React into this
 * module so the validator classes (plain, non-React code) can read it
 * synchronously. Synced by `RelaxDraftValidationFlagSync`.
 *
 * Defaults to `false` (the pre-flag, channel-specific-media-required
 * behavior) so an unmounted sync component or a not-yet-ready SDK never
 * relaxes validation by accident.
 */
let isRelaxDraftValidationEnabled = false

export function setRelaxDraftValidationEnabled(enabled: boolean): void {
  isRelaxDraftValidationEnabled = enabled
}

export function getRelaxDraftValidationEnabled(): boolean {
  return isRelaxDraftValidationEnabled
}
